const INSTANCE_ROOT = import.meta.env.VITE_INSTANCE_ROOT || "";
export const INSTANCE_URL = INSTANCE_ROOT ? `https://${INSTANCE_ROOT}` : "";
export const INSTANCE_WS_URL = INSTANCE_ROOT
  ? `wss://${INSTANCE_ROOT}`
  : "wss://engineears-215922.appspot.com";
export const VERSION = import.meta.env.VITE_VERSION || "development";
export const ENV = import.meta.env.MODE || "development";
export const IS_DEVELOPMENT_MODE =
  ENV === "development" || VERSION === "development";
export const SUPPLY_CHAIN_ACTIVE =
  ENV === "development"
    ? false
    : import.meta.env.VITE_SUPPLY_CHAIN_ACTIVE === "true" || false;
